import HomePage from "../components/HomePage";
import StaticPage from "./../components/StaticPage";
import LoginPage from "../components/LoginPage";
import CanonProjects from "../components/canon/projects"
import CanonProducts from "../components/canon/products/"
import HashLogin from "../components/HashLogin";
import Customers from "../components/canon/customers";
import CustomerForm from "../components/canon/customers/CustomerForm";


export const ROUTES = [
    {
        path: "/",
        name: "HOME-PAGE",
        exact: true,
        component: HomePage,
        fetch: true,
        loginRequired: true,
        withoutTemplate: false,
    },
    {
        path: "/login",
        name: "LOGIN",
        component: LoginPage,
        loginRequired: false,
        withoutTemplate: false,
    },
    {
        path: '/hash-login/:hash',
        name: 'HASH-LOGIN',
        component: HashLogin,
        loginRequired: 'both',
        withoutTemplate: true,
    },
    {
        path: '/:vendor/i-sensys-projects',
        name: 'CANON-PROJECTS',
        component: CanonProjects,
        loginRequired: true,
        withoutTemplate: false,
    },
    {
        path: '/:vendor/i-sensys-products',
        name: 'CANON-PRODUCTS',
        component: CanonProducts,
        loginRequired: true,
        withoutTemplate: false,
    },
    {
        path: '/:vendor/projects',
        name: 'PROJECTS',
        component: CanonProjects,
        loginRequired: true,
        withoutTemplate: false,
    },
    {
        path: '/:vendor/products',
        name: 'PRODUCTS',
        component: CanonProducts,
        loginRequired: true,
        withoutTemplate: false,
    },
    {
        path: "/page/:page",
        name: "STATICPAGE",
        component: StaticPage,
        loginRequired: true,
        withoutTemplate: false,
    },
    {
        path: '/customers',
        name: 'customers',
        component: Customers,
        loginRequired: true,
        withoutTemplate: false
    },
    {
        path: '/customer/:id',
        name: 'update_customer',
        component: CustomerForm,
        loginRequired: true,
        withoutTemplate: false
    },
];

export const ROUTES_BY_ID = (function(){
    let result = {};
    ROUTES.forEach((element) => {
        result[element.name] = element;
    });
    return result;
}());
